import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import styles from './menu.module.scss';
import CloseIcon from '../../../icons/cancel.svg';
import Clickable from '../../clickable/Clickable';
import FormattedMessageWithClass from '../../formattedMessageWithClass/FormattedMessageWithClass';
import { useAllModules } from './UseAllModules';

const Menu = ({ items, history, handleIconClick }) => {
  const currentPath = history.location.pathname;
  const modules = useAllModules(items, currentPath);

  const [activeMenu, setActiveMenu] = useState(modules.find(s => s.isActive)?.menu_key || modules[0].menu_key);

  const handleActiveMenu = (menu) => {
    setActiveMenu(menu);
  };


  return (
    <div className={styles.menu}>
      <div className={styles.mainMenu}>
        {
          modules.map((item) => {
            const isActive = activeMenu === item.menu_key;
            return (
              <Clickable
                onClick={() => handleActiveMenu(item.menu_key)}
                className={`${styles.menuItem} ${isActive && styles.activeMenuItem}`}
              >
                <div className={`${styles.outerSide} ${isActive && styles.outerSideActive}`}>
                  <img src={item.icon} alt="" className={`${styles.outerSideImg} ${isActive && styles.outerSideImgActive}`} />
                </div>
                <FormattedMessageWithClass
                  id={item.id}
                  defaultMessage={item.name}
                />
              </Clickable>
            );
          })
        }
      </div>
      <div className={styles.subMenu}>
        <div className={styles.subHeader}>
          <div className="d-flex align-items-center" style={{ gap: '8px' }}>
            <img src={modules.find(i => i.menu_key === activeMenu).icon} alt="" className={styles.imgIcon} />
            <span style={{ fontSize: '17px' }}>
              <FormattedMessageWithClass
                id={modules.find(i => i.menu_key === activeMenu).id}
                defaultMessage={modules.find(i => i.menu_key === activeMenu).name}
              />
            </span>
          </div>
          <Clickable onClick={handleIconClick}>
            <img src={CloseIcon} alt="CloseIcon" style={{ height: '14px' }} />
          </Clickable>
        </div>
        <div style={{ overflowY: 'auto', height: 'calc(100% - 58px)' }}>
          {
            modules.find(i => i.menu_key === activeMenu)
            .subMenu.filter(i => i.permission).map((item) => {
              const { pathname } = item;
              const isActive = pathname === currentPath;
              return (
                <Link
                  onClick={handleIconClick}
                  className={`${styles.subMenuItem} ${isActive && styles.activeSubMenuItem}`}
                  to={item.pathname}
                >
                  <FormattedMessageWithClass
                    id={item.id}
                    defaultMessage={item.name}
                  />
                </Link>
              );
            })
          }
        </div>
      </div>
    </div>
  );
};

export default withRouter(Menu);
